import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ButtonComponent from "../common/Button"
import "./delete-account.css"
import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Modal } from '@material-ui/core';
import { toast } from 'react-toastify';

const DeleteUser = () => {
   const [open, setOpen] = useState(false)
   const [deleteUserData, setDeleteUserData] = useState({
      phoneNumber: ""
   })
   const [errors, setErrors] = useState({})

   const PHONE_NUMBER_COUNT = 10
   const onlyNumberRegex = RegExp(/^\d+$/);

   const validateDataOnChange = (name, value = "", preserveError) => {
      let errors = { ...preserveError };

      switch (name) {
         case "phoneNumber":
            value = value.trim()
            if (!value) {
               errors.phoneNumberError = "This field is required.";
            } else if (!onlyNumberRegex.test(value)) {
               errors.phoneNumberError = "Only numbers are acceptable";
            } else if (value.length !== PHONE_NUMBER_COUNT) {
               errors.phoneNumberError = "Enter 10 digit Mobile number";
            } else {
               delete errors.phoneNumberError
            }
            break;
         default:
            break;
      }

      return errors;
   };

   const validateData = (quateData) => {
      let errors = {};
      const {
         phoneNumber = "",
      } = quateData;

      let phoneNumberValue = phoneNumber.trim();

      if (!phoneNumberValue) {
         errors.phoneNumberError = "This field is required.";
      } else if (!onlyNumberRegex.test(phoneNumberValue)) {
         errors.phoneNumberError = "Only numbers are acceptable";
      } else if (phoneNumberValue.length !== PHONE_NUMBER_COUNT) {
         errors.phoneNumberError = "Enter 10 digit Mobile number";
      }

      return errors;
   };

   const handleInputChange = (event) => {
      const { name, value } = event.target

      const errorsMess = validateDataOnChange(name, value, errors)
      setErrors(errorsMess)

      setDeleteUserData({
         ...deleteUserData,
         [name]: value
      })
   }

   const handleSubmit = () => {
      try {
         const errorsMess = validateData(deleteUserData)
         setErrors(errorsMess)

         if (Object.keys(errorsMess).length > 0) {
            return
         }

         setOpen(true)
      } catch (error) {
         console.log(error);
      }
   }

   const conformSubmit = () => {
      try {
         setErrors({})
         setOpen(false)
         setDeleteUserData({
            phoneNumber: ""
         })
         toast.success("Your account is deleted successfully.")
      } catch (error) {
         console.log(error);
      }
   }
   return (
      <>
         <div id="landingPage" className='faq-header'>
            <Navbar />
         </div >
         <main className='container details-section'>
            <div className="del-page">
               <div className='del-form'>
                  <h2>Delete User Account</h2>

                  <input
                     name="phoneNumber"
                     type="text"
                     placeholder='Phone'
                     className="del-input"
                     value={deleteUserData.phoneNumber}
                     onChange={(event) => handleInputChange(event)}
                     required
                  />

                  {
                     errors && errors.phoneNumberError ? (
                        <span className='error-message'>{errors.phoneNumberError}</span>
                     ) : <></>
                  }
                  {/* <h5>OR</h5>
                  <input name="name" type="email" placeholder='Email' className="del-input" value="" /> */}
                  <ButtonComponent
                     label={"Delete Account"}
                     onClick={() => handleSubmit()}
                     className="del-btn" /></div>
            </div>
         </main>
         <Footer />
         <Dialog onClose={() => { }} aria-labelledby="customized-dialog-title" open={open} scroll={'body'} >
            <DialogTitle id="customized-dialog-title" onClose={() => { }}>
               Delete User Account
            </DialogTitle>
            <DialogContent dividers>
               <h3 className='modal-info'>
                  Are you sure you want to delete account?
               </h3>

               <div className='modal-options-wrap'>
                  <ButtonComponent label={"No"} onClick={() => setOpen(false)} />
                  <ButtonComponent label={"Yes"} onClick={() => conformSubmit()} />
               </div>
            </DialogContent>
         </Dialog >
      </>
   )
};

export default DeleteUser;
